import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import inputStyle from './text-input.scss';
import TextInput from '../text-input/index';
import listStyle from './dropdown-list.scss';
import DropDownList from '../dropdown-list/index';
import StudentCount from '../student-count/index';
import ClassroomGroupList from '../classroom-group-list/index';
import css from './index.scss';
import messages from './messages';

const ClassDetail = ({
    intl,
    classroomDetail,
    yearGroups,
    downloadStudentSignInCards,
    isDownloadingSignInCards,
    handleOnClassNameChange,
    className,
    handleOnEditGroup,
    handleOnYearGroupChange,
    yearGroup,
    openAddGroup,
    selectedProduct,
    handleOnStudentSignInCards,
    handleOnCancelStudentSignInCards,
    showHideSignInCardModal,
    displayNewCourses
}) => (
    <div className={css.classDetailComponent}>
        <div className={css.title}>{intl.formatMessage(messages.classDetails)}</div>
        <div className={css.panel}>
            <span className={css.label}>{intl.formatMessage(messages.className)}</span>
            <div className={css.input}>
                <TextInput
                    css={inputStyle}
                    handleOnChange={handleOnClassNameChange}
                    maxLength={200}
                    name="className"
                    value={className}
                />
            </div>
            <span className={css.label}>{intl.formatMessage(messages.year)}</span>
            <div className={css.list}>
                <DropDownList
                    css={listStyle}
                    name="yearGroupEnum"
                    onChange={handleOnYearGroupChange}
                    options={yearGroups}
                    value={yearGroup} />
            </div>
            <div className={css.studentColumn}>
                <span className={css.label}>{intl.formatMessage(messages.students)}</span>
                <StudentCount count={classroomDetail.studentsProfileId.length} icon={css.studentCountIcon} />
            </div>
        </div>
        <ClassroomGroupList
            classroomDetail={classroomDetail}
            displayNewCourses={displayNewCourses}
            downloadStudentSignInCards={downloadStudentSignInCards}
            handleOnCancelStudentSignInCards={handleOnCancelStudentSignInCards}
            handleOnEditGroup={handleOnEditGroup}
            handleOnStudentSignInCards={handleOnStudentSignInCards}
            isDownloadingSignInCards={isDownloadingSignInCards}
            openAddGroup={openAddGroup}
            selectedProduct={selectedProduct}
            showHideSignInCardModal={showHideSignInCardModal}
            yearGroup={yearGroup}
        />
    </div>
);

ClassDetail.propTypes = {
    intl: intlShape.isRequired,
    classroomDetail: PropTypes.object,
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    downloadStudentSignInCards: PropTypes.func,
    isDownloadingSignInCards: PropTypes.bool,
    handleOnClassNameChange: PropTypes.func,
    className: PropTypes.string,
    handleOnEditGroup: PropTypes.func,
    handleOnYearGroupChange: PropTypes.func,
    openAddGroup: PropTypes.func,
    yearGroup: PropTypes.string,
    selectedProduct: PropTypes.object,
    handleOnStudentSignInCards: PropTypes.func,
    handleOnCancelStudentSignInCards: PropTypes.func,
    showHideSignInCardModal: PropTypes.bool,
    displayNewCourses: PropTypes.bool
};

export default injectIntl(styleable(css)(ClassDetail));



// WEBPACK FOOTER //
// ./app/components/class-detail/index.js